import styles from "./ApprovedTickets.module.scss";

export const getApprovedTicketColumns = () => [
  {
    title: "Ticket No",
    sorter: false,
    width: "140px",
    key: "ticketNumber",
    align: "center",
    dataIndex: "ticketNumber",
    render: (ticketNumber) => {
      return <span className="table-font-mobile">{ticketNumber} </span>;
    },
  },
  {
    title: "Truck No",
    sorter: false,
    width: "140px",
    key: "truckNumber",
    align: "center",
    dataIndex: "truckNumber",
    render: (truckNumber, record) => {
      return <span className="table-font-mobile">{truckNumber}</span>;
    },
  },
  {
    title: "Customer Name",
    sorter: false,
    width: "140px",
    key: "companyName",
    align: "center",
    dataIndex: "companyName",
    render: (companyName, record) => {
      return <span className="table-font-mobile">{companyName}</span>;
    },
  },
  {
    title: "Job ID",
    sorter: false,
    width: "140px",
    key: "jobNumber",
    align: "center",
    dataIndex: "jobNumber",
    render: (jobNumber, record) => {
      return <span className="table-font-mobile">{jobNumber} </span>;
    },
  },
  {
    title: "Job Name",
    sorter: false,
    width: "140px",
    key: "jobName",
    align: "center",
    dataIndex: "jobName",
    render: (jobName, record) => {
      return <span className="table-font-mobile">{jobName} </span>;
    },
  },
  {
    title: "Order",
    sorter: false,
    width: "140px",
    key: "orderNumber",
    align: "center",
    dataIndex: "orderNumber",
    render: (orderNumber, record) => {
      return <span className="table-font-mobile">{orderNumber}</span>;
    },
  },
  {
    title: "Units",
    sorter: false,
    width: "140px",
    align: "center",
    key: "quantity",
    align: "center",
    dataIndex: "quantity",
    render: (quantity, record) => {
      return <span className="table-font-mobile">{quantity}</span>;
    },
  },
];

export const buttonParams = {
  title: "Generate Invoices",
};

export const getApprovedTicketModalParams = (ticketCount?: number) => {
  return {
    confirmGenerateInvoice: <>{"Are you sure you want to generate invoice for "}{<span className={styles.countHighlight}>{ticketCount}</span>}{" ticket(s)?"}</>,
    title: "Confirm Generate Invoice",
    okButtonLabel: "Confirm",
  };
};

export const textConsts = {
  TOTAL_BATCH_FAILURE:
    "Invoices not generated due to not all tickets in a batch are approved",
  PARTIAL_BATCH_FAILURE:
    "Some Invoices are not generated due all tickets in the batch not being approved",
  SOMETHING_WENT_WRONG: "Something went wrong",
};
